import { IGlobalAction } from "../interfaces/states/IGlobalAction";
import { IGlobalState } from "../interfaces/states/IGlobalState";
import { profitLossFilterInitialState, profitLossFiltersReducer } from "./profit-loss-filter-reducer";
import { transactionFilterInitialState, transactionFiltersReducer } from "./transaction-filter-reducer";


export const globalInitialState: IGlobalState = {
    transactionFilters: transactionFilterInitialState,
    profitLossFilters: profitLossFilterInitialState
};


export function globalReducer(state: IGlobalState, action: IGlobalAction): IGlobalState {
    return {
        transactionFilters: transactionFiltersReducer(state.transactionFilters, action),
        profitLossFilters: profitLossFiltersReducer(state.profitLossFilters, action)
    };
}